export const SEARCHABLE_TYPES = ['artworks', 'artists'] as const;
export type SearchableTypes = typeof SEARCHABLE_TYPES[number];
